import {useMutation} from 'react-query';
import {paymentAPI} from 'api';
import {simulateTransfer} from 'api/routes/wallet';

export const useSimulateTransfer = ({onSuccess, onError, headers = {}} = {}) => {
    const simulateTransferMutation = useMutation(
        async ({amount, account_number}) => {
            const response = await paymentAPI.post(
                simulateTransfer,
                {amount, account_number},
                {headers}
            );
            return response?.data;
        },
        {onSuccess, onError}
    );

    return simulateTransferMutation;
};
